import api from '../../api-request';
import apiCrm from "../../crm-request";
// 企微客户列表
function getCustomerList (params) {
  return api.post('/potential-customer/customer/list', params);
}
// 意向评级
function getLabelType (params) {
  return api.get(`/potential-customer/intention/used/labelType`,{params});
}


// 企微客户搜索中的负责人列表
function getUserOrder (params) {
  return api.get(`/traffic/get/users/getUserOrder`,{params});
}
// 打标签
function batchEdit (params) {
  return api.post('/potential-customer/label/batch/edit', params);
}

// 同步
function customerUserSync () {
  return api.get('/potential-customer/customer/user/sync');
}

// 同步次数
function getSyncNum () {
  return api.get('/external-contact/sync/count');
}

// 企微客户详情
function customerDetail (customerExtendId) {
  return api.get(`/potential-customer/customer/detail/${customerExtendId}`);
}

// 用户日志
function getCustomerLogs (customerExtendId, params) {
  return api.get(`/potential-customer/customer/logs/${customerExtendId}`, {params});
}

// 企微客户详情 - 单个转crm
function customerDetailTransfer (params) {
  return api.post('/potential-customer/crm/customer/transfer', params);
}

// 企微客户列表 - 关联联系人
function customerListTransfer (params) {
  return api.post('/potential-customer/crm/customer/batchTransfer', params);
}

// 企微客户详情 - 单个解绑
function unbindCrm (params) {
  return api.get('/potential-customer/crm/customer/unbind', {params});
}

// H5页面相关接口 - 企微客户详情
function getUserDetailInfo (customerExtendId) {
  return api.get(`/potential-customer/mobile/customer/${customerExtendId}`);
}
// 标签
function getLabelList (customerExtendId) {
  return api.get(`/potential-customer/mobile/label/${customerExtendId}`);
}
// 编辑标签
function editLabel (params) {
  return api.post('/potential-customer/mobile/label/edit', params);
}
// 编辑企微客户信息
function editUserInfo (params) {
  return api.post('/potential-customer/mobile/customer/edit', params);
}
// 企微客户群聊 - 详情
function getCustomerGroup (params) {
  return api.post('/marketing-tool/mobile/group', params);
}
// 查询当前用户在crm的操作权限
function getCrmPermission () {
  return api.get('/potential-customer/crm/user/permission');
}
// 推送消息弹窗
function pushMessageResult () {
  return api.get('/potential-customer/crm/message/popup');
}
// 点击跳转到crm
function getCustomerId (params) {
  return api.get('/potential-customer/crm/customerId/byContactId',{params});
}
// 获取用户轨迹
function getTrajectory(params) {
  let extendId = params.extendId
  delete params.extendId
  return api.get(`/potential-customer/customer/trailEvent/${extendId}`, {params})
}

function getCrmId(params) {
  return api.get('/potential-customer/crm/customerId/byContactId', {params})
}

// 开启自动同步到CRM
function openSync(params) {
  return api.post(`/potential-customer/autoSync/${params.flag}/open`)
}

// 查询是否开启自动同步到CRM
function getIsSync() {
  return api.get(`/potential-customer/autoSync/isOpen`)
}

// 查询员工是否首次使用
function getIsFirst() {
  return api.get(`/potential-customer/autoSync/isFirst`)
}

// 设置员工首次使用
function setIsFirst() {
  return api.get(`/potential-customer/autoSync/setFirst`)
}
//活码标签
function getTrafficLabels() {
  return api.get("/marketing-tool/common/get/labels");
}
// 查询企业意向评级规则列表
function getIntentionList () {
  return api.get('/potential-customer/intention/list')
}
// 查询客户类型
function getCustomerType () {
  return api.get('/potential-customer/crm/fieldTemplates')
}
// 客户关联入参
function setCustomerEntity (params) {
  return api.post('/potential-customer/customer/remedy/customerEntity',params)
}
// SCRM融合迭代流失列表/删除人提醒列表的crm接口
function getScrmCustomerExtendsTempList(params) {
  return apiCrm.get('/pc/scrm_customer_extends/temp_list',  {params})
}
export default {
  getCustomerList,
  batchEdit,
  customerUserSync,
  customerDetail,
  getCustomerLogs,
  getSyncNum,
  customerDetailTransfer,
  unbindCrm,
  customerListTransfer,
  getUserDetailInfo,
  getLabelList,
  editLabel,
  editUserInfo,
  getCustomerGroup,
  getCrmPermission,
  pushMessageResult,
  getCustomerId,
  getTrajectory,
  getCrmId,
  openSync,
  getIsSync,
  getIsFirst,
  setIsFirst,
  getTrafficLabels,
  getIntentionList,
  getUserOrder,
  getLabelType,
  getCustomerType,
  setCustomerEntity,
  getScrmCustomerExtendsTempList
}
